/* ************************************************************
src/loaders/RequiresAuth.jsx
사용자가 페이지에 접근하면, 페이지를 렌더링하기 전에 
Loader 함수를 통해 승인 여부를 확인.
**************************************************************/
import { redirect, LoaderFunctionArgs } from 'react-router-dom';

// 1. 사용자 정보 인터페이스 정의
interface User {
  name: string;
  age: number;
}

// 사용자 정보를 가져오는 가상 함수
async function getUser(): Promise<User | null> {
  const token = localStorage.getItem('access_token');
  
  /* 실제 API 호출 시 예시:
  const res = await fetch('https://api.heropy.dev/user/me', {
    headers: { 'Authorization': `Bearer ${token}` }
  });
  if (!res.ok) return null;
  return res.json() as Promise<User>;
  */
  
  if (token) {
    return { name: 'Neo', age: 22 };
  }
  return null;
}

/**
 * 페이지 접근 시 호출되는 로더(Loader) 함수
 * LoaderFunctionArgs 타입을 사용하여 매개변수 타입을 지정합니다.
 */
export async function requiresAuth({ request }: LoaderFunctionArgs) {
  const user = await getUser();

  if (!user) {
    const url = new URL(request.url);
    const redirectTo = url.pathname + url.search;
    
    // 리다이렉트 처리
    return redirect(`/signin?redirectTo=${encodeURIComponent(redirectTo)}`);
  }

  // 로그인된 경우 사용자 데이터 반환 (컴포넌트에서 useLoaderData<User>()로 사용 가능)
  return user;
}